export default __webpack_public_path__ + "static/media/Logo00-300x150.82ad746c.png";